import React from 'react';
import { Menu } from '@mui/material';
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { closeMenu, openMenu } from '../redux/reducer/menu/menuSlice';
import { RootState } from '../redux/store';
import NotificationList from '../pages/notification/NotificationList';
import { NAVIGATE_NOTIFICATION } from '../routes/ConstantRoutes';

const CommonMenuDialog: React.FC = () => {
  const { focus } = useSelector((state: RootState) => state.menu);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleMenusClose = () => {
    dispatch(openMenu({ isOpen: false, type: "", focus: null }));
    dispatch(closeMenu());
  };

  const handleViewMore = () => {
    dispatch(closeMenu());
    navigate(NAVIGATE_NOTIFICATION.NOTIFICATION);
  };

  return (
    <Menu
      anchorEl={focus}
      open={true}
      onClose={handleMenusClose}
      PaperProps={{  border:"2px solid black",
        style: {
          maxHeight: 400,
          width: 360,
        },
      }}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
    >
      <NotificationList onViewMore={handleViewMore} />
    </Menu>
  );
};

export default CommonMenuDialog;
